import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[vaControlHost]',
  standalone: false,
})
export class ControlHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
